import React, { Children } from 'react';
import { Box } from '@mui/material';

export interface TriageRowProps {
  children?: React.ReactNode;
}

export const TriageRow = ({ children }: TriageRowProps) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'minmax(260px, 1.6fr) minmax(150px, 0.8fr) minmax(150px, 0.8fr) minmax(220px, 1fr)',
      alignItems: 'center',
      gap: 1.5,
      minWidth: { xs: 760, md: 900 },
      px: { xs: 1.25, md: 1.75 },
      py: { xs: 1.1, md: 1.25 },
    }}
  >
    {Children.map(children, (child) => (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          minWidth: 0,
        }}
      >
        {child}
      </Box>
    ))}
  </Box>
);
